// extracted by mini-css-extract-plugin
export default {"container":"SubLayout_container__PxF5w","sub_container":"SubLayout_sub_container__ygKdU"};